export const API_URL = process.env.REACT_APP_REST_API_URL;
export const API = process.env.REACT_APP_API_ADMIN;
// export const API_URL = 'http://localhost:5051/graphql/';
// export const API = 'http://localhost:5051/graphql/';
// export const API_URL = 'https://api.gayalo.com/';
// export const API = 'https://api.gayalo.com/graphql/';
